module.exports = __webpack_public_path__ + "static/media/check_on.06f13f28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check_on.svg
// module id = 160
// module chunks = 0